module.exports = __webpack_public_path__ + "img/newavatar.e262c858.svg";